/**
 * Schalter für den Reiter „Retoure“ (Stufe 1, vorbereitet, nicht aktiviert).
 *
 * Vorgabe AUS. Eingeschaltet nur, wenn im Gerätespeicher `bilanx.retoureStufe1` genau `1` steht
 * (Entwicklung, Sichtprüfung). Es gibt keinen Schalter in der Oberfläche. Auch eingeschaltet kann
 * die Kasse keine Retoure abschließen: Der Reiter nutzt ausschließlich lesende Abrufe, eine
 * Retourenroute gibt es am Server nicht (Freigaben RF-1/RF-2/RF-4, E-SB-1 und Rechtekonzept offen).
 */
export const RETOURE_SCHALTER = 'bilanx.retoureStufe1';

/** Text des Reiters (offene Entscheidung RT-F2: in Stufe 1 ohne Umtausch nur „Retoure“). */
export const RETOURE_REITER_TEXT = 'Retoure';

export function retoureStufe1Aktiv(speicher: Pick<Storage, 'getItem'>): boolean {
  try {
    return speicher.getItem(RETOURE_SCHALTER) === '1';
  } catch {
    return false; // gesperrter Speicher (privater Modus) = aus
  }
}

/** Reitereintrag für die Kopfzeile – leer, solange der Schalter aus ist. */
export function retoureReiter(
  speicher: Pick<Storage, 'getItem'>,
): { id: 'retoure'; text: string }[] {
  return retoureStufe1Aktiv(speicher) ? [{ id: 'retoure', text: RETOURE_REITER_TEXT }] : [];
}
